import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  statsWrap: FelaCSS;
  noReviewsLabel: FelaCSS;
  buttonWrap: FelaCSS;
  totalWrapper: FelaCSS;
  iconWrap: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },

  totalWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    color: colors.space60,
  },

  iconWrap: {
    top: '3px',
  },

  statsWrap: {
    flexDirection: 'row',
  },

  noReviewsLabel: {
    color: colors.alto,
  },

  buttonWrap: {
    marginLeft: spacing[6],

    maxWidthMobile: {
      display: 'none',
    },
  },
};

export default styles;
